export const EXPERIMENT = {
    VIPERS_FREELANCER_PAGE: 3381,
    VIPERS_FREELANCER_CATEGORY_NAVBAR: 3608,
    MUSTANGS_VETTED_BADGE_TEST: 4066,
};

export const VARIANTS = {
    A: '1',
    B: '2',
    C: '3',
};
